import React, { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const Contact = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    // Open contact popup when accessing /contact directly
    if (window.openContactPopup) {
      window.openContactPopup();
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-kioo-dark mb-4">{t('contact.title')}</h1>
        <p className="text-gray-600 mb-6">{t('contact.getInTouch')}</p>
        <button
          onClick={() => window.openContactPopup && window.openContactPopup()}
          className="bg-kioo-primary text-white px-6 py-3 rounded-lg hover:bg-kioo-secondary transition-colors"
        >
          {t('contact.sendMessage')}
        </button>
      </div>
    </div>
  );
};

export default Contact;